export default __webpack_public_path__ + "static/media/starimg_grey.5090f487.svg";